const routes = [
  {
    path: "settings",
    component: () => import("@/views/Settings/Main.vue"),
    redirect: { name: "settings-index" },
    name: "settings",
    meta: { role: ["administrator", "superadmin", "system_admin"] },

    children: [
      {
        path: "main",
        component: () => import("@/views/Settings/Index.vue"),
        name: "settings-index",
      },
      {
        path: "audience-import",
        component: () => import("@/views/Settings/AudienceImport.vue"),
        name: "settings-audience-import",
      },
      {
        path: "media",
        component: () => import("@/views/Settings/MediaPage.vue"),
        name: "settings-media",
        redirect: { name: "settings-media-main" },
        children: [
          {
            path: "main",
            component: () => import("@/views/Settings/Media.vue"),
            name: "settings-media-main",
          },
          {
            path: ":id/media-audience",
            component: () => import("@/views/Settings/MediaAudience.vue"),
            name: "settings-media-audience",
          },
        ],
      },
      {
        path: "medium-types",
        component: () => import("@/views/Settings/MediumTypes.vue"),
        name: "settings-medium-types",
      },
      {
        path: "users",
        component: () => import("@/views/Settings/Users.vue"),
        name: "settings-users",
      },
      {
        path: "support",
        component: () => import("@/views/Settings/SupportForm.vue"),
        name: "settings-support",
        meta: {
          title: "Richiesta di Supporto",
        },
      },
    ],
  },
];

export default routes;
